import {SuccessfulApiResponse} from "@eryxcoop/appyx-comm";

export default class GetEnabledDeliveryDatesResponse extends SuccessfulApiResponse {
    static defaultResponse() {
        return {
            object: [
                "05-06-2024",
                "07-06-2024",
                "12-06-2024",
                "14-06-2024"
            ],
            errors: []
        }
    }

    responseEnabledDates() {
        return this.content().map(date => {
            const [day, month, year] = date.split('-');
            return new Date(year, month - 1, day);
        });
    }

}